import { TTopCategory } from 'data';
import { getTopCategoriesId } from './get-top-categories-id';
import { findTopCategoryData } from './find-data-helpers';

type TGetFoundCardsNumber = (
	topCategories: TTopCategory[],
	selectedFilterItems: number[]
) => number;

export const getFoundCardsNumber: TGetFoundCardsNumber = (topCategories, selectedFilterItems) => {
	let foundCardsNumber = 0;

	const topCategoriesId = getTopCategoriesId(topCategories);

	const topCategoriesArray = selectedFilterItems.length ? selectedFilterItems : topCategoriesId;

	topCategoriesArray.forEach(categoryId => {
		const { categories } = findTopCategoryData(topCategories, categoryId);
		foundCardsNumber += categories.length;
	});
	return foundCardsNumber;
};
